<template>
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <slot name="content">
            <div class="numbers">
              <p class="card-category text-center">{{smallTitle}}</p>
              <p class="card-title text-center" v-if="smallTitle !== '색상' && type === 'string'">{{title}}{{unit}}</p>
              <p class="card-title text-center" v-if="type === 'number'">{{ title | numeral('0,0')}}{{unit}}</p>
              <el-button v-if="smallTitle === '색상'" :style="'background-color:' +  title" circle></el-button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import vueNumeralFilterInstaller from 'vue-numeral-filter';

  Vue.use(vueNumeralFilterInstaller)

  export default {
    name: 'stats-card',
    props:{
      type: {
        type: String,
      },
      title: {
        description: 'Card title'
      },
      smallTitle: {
        type: String,
        description: 'Card small title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      },
      unit: {
          type: String,
      }
    }
  }

</script>
<style scoped>
  .card-content{
    min-height: 85px
  }
</style>
